module.exports = __webpack_public_path__ + "img/icon_img16.png";